import DSBaseInput from "@/src/design_system/form_elements/base_input/components/DSBaseInput.vue";
import { VueComponentTemplateRef } from "@/src/shared/types/vueTemplateRef";

interface UseSelectFocusInput {
  focusBaseInput: () => void;
}

export const useSelectFocusInput = (baseInputRef: VueComponentTemplateRef<typeof DSBaseInput>): UseSelectFocusInput => {
  const focusBaseInput = () => {
    (baseInputRef.value as { focus?: () => void } | null)?.focus?.();
  };

  return { focusBaseInput };
};
